module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"cool-hunter","short_name":"coolhunter","start_url":"/","background_color":"#232323","theme_color":"#B18667","display":"minimal-ui","icon":"static/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"6440d1f7f2220f1c0ae75762279cdb48"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
